module.exports = __webpack_public_path__ + "media/images/steps/svg/255-businessman-5-b83cc591e96f6c60ba11011aceb44573.svg";